module.exports = __webpack_public_path__ + "img/exclamation-octagon.a582b0d0.svg";